import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const SocialFacebookBase = (
  <g transform='translate(4 4)'>
    <path fill='#1976D2' d='M21 0H3C1.345 0 0 1.345 0 3v18c0 1.654 1.345 3 3 3h18c1.654 0 3-1.346 3-3V3c0-1.655-1.346-3-3-3z' />
    <path fill='#FAFAFA' d='M20.25 12H16.5V9c0-.828.672-.75 1.5-.75h1.5V4.5h-3C14.014 4.5 12 6.514 12 9v3H9v3.75h3V24h4.5v-8.25h2.25l1.5-3.75z' />
  </g>
)

export const SocialFacebook = createIcon({
  displayName: 'SocialFacebook',
  viewBox: '0 0 32 32',
  path: SocialFacebookBase,
})

export const SocialGoogleBase = (
  <g transform='translate(4 4)'>
    <path
      fill='#FBBD00'
      d='M5.625 12c0-1.19.328-2.303.897-3.257V4.698H2.476C.87 6.783 0 9.324 0 12c0 2.676.87 5.217 2.476 7.302h4.046v-4.045c-.57-.954-.897-2.068-.897-3.257z'
    />
    <path fill='#0F9D58' d='M12 18.375l-2.813 2.813L12 24c2.676 0 5.217-.87 7.302-2.476v-4.041h-4.041c-.962.57-2.08.892-3.261.892z' />
    <path
      fill='#31AA52'
      d='M6.522 15.257l-4.046 4.045c.318.413.664.809 1.039 1.183C5.78 22.752 8.795 24 12 24v-5.625c-2.326 0-4.365-1.253-5.478-3.118z'
    />
    <path
      fill='#3C79E6'
      d='M24 12c0-.73-.066-1.462-.197-2.174l-.105-.576H12v5.625h5.693c-.553 1.1-1.403 1.997-2.432 2.608l4.041 4.041c.413-.318.809-.664 1.183-1.039C22.752 18.22 24 15.205 24 12z'
    />
    <path
      fill='#CF2D48'
      d='M16.508 7.492l.497.497 3.977-3.977-.497-.497C18.22 1.248 15.205 0 12 0L9.187 2.813 12 5.624c1.703 0 3.304.663 4.508 1.867z'
    />
    <path
      fill='#EB4132'
      d='M12 5.625V0C8.795 0 5.781 1.248 3.515 3.515c-.375.374-.721.77-1.039 1.183l4.046 4.045C7.635 6.878 9.674 5.625 12 5.625z'
    />
  </g>
)

export const SocialGoogle = createIcon({
  displayName: 'SocialGoogle',
  viewBox: '0 0 32 32',
  path: SocialGoogleBase,
})
